var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"round-button xs-f-small lg-f-medium max-at-tweak",class:{ selected: _vm.selected, disabled: _vm.disabled },attrs:{"type":"button"},on:{"click":_vm.buttonClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }